import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "loading-slug" }
const _hoisted_4 = {
  key: 1,
  class: "error-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "main-content" }, {
    default: _withCtx(() => [
      (!$setup.show404)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($setup.loaderIconSrc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.loaderIconSrc,
                  class: "loader-app-icon",
                  alt: "",
                  onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onLoaderIconError && $setup.onLoaderIconError(...args)))
                }, null, 40, _hoisted_2))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_progress_bar, { value: $setup.progress }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_3, _toDisplayString($setup.loadingSlug), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
            _createElementVNode("h1", null, "404", -1),
            _createElementVNode("p", null, "The resource you requested does not exist or is no longer available.", -1)
          ])))
    ]),
    _: 1
  }))
}